import { client } from '@/client';

// Cluster角色
export function getRoles(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/console/security/${clusterName}/roles`, others);
}

// 权限类型
export function getAuthType() {
  return client.get('/api/console/dictionary/getAuthType');
}

// 新增role
export function addRole(data) {
  return client.put('/api/console/security/createRole', data);
}

// 修改role
export function updateRole(data) {
  return client.put('/api/console/security/updateRoleNote', data);
}

// 上传文件
export function uploadKeyFile(body) {
  return client.form('/api/console/security/uploadSecretKey', body);
}

// 删除角色
export function deleteRole(params) {
  return client.delete('/api/console/security/deleteRole', params);
}

// 是否已经上传秘钥
export function isUploadSecretKey(clusterName) {
  return client.get('/api/console/security/isUploadSecretKey', { clusterName });
}

// 获取授权列表
export function getGrants(params) {
  const { clusterName, ...others } = params || {};
  return client.get(`/api/resource/security/${clusterName}/rolePermissions`, others);
}

// 获取集群下Role
export function getClusterRoles(params) {
  const { clusterName, ...others } = params || {};
  return client.get(`/api/resource/cluster/${clusterName}/roles`, others);
}

// 根据认证方式获取资源
export function getClusterResources(params) {
  const { clusterName, ...others } = params || {};
  return client.get(`/api/resource/security/${clusterName}/clusterResources`, others);
}

// 根据认证方式获取KOP资源
export function getKopClusterResources(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/resource/kop/security/${clusterName}/resources`, others);
}

// 添加权限
export function createPermission(params) {
  return client.put('/api/resource/security/createPermission', params);
}

// 修改权限
export function updatePermission(params) {
  return client.put('/api/resource/security/updatePermission', params);
}

// 删除权限
export function deletePermission(params) {
  return client.delete('/api/resource/security/deletePermission', params);
}
